const osNameMap = {
    0: 'Windows',
    1: 'Mac',
    2: 'Linux',
    3: 'Android',
    4: 'IOS',
};
const osTypeMap = {};
Object.keys(osNameMap).forEach((currKey) => {
    const currVal = osNameMap[currKey];
    osTypeMap[currVal] = currKey;
});
const deviceTypeMap = {
    '0': 'PERSONAL',
    '1': 'COMPANY',
    '-1': 'UNKNOWN',
};
const deviceTypeValueMap = {};
Object.keys(deviceTypeMap).forEach((currKey) => {
    const currVal = deviceTypeMap[currKey];
    deviceTypeValueMap[currVal] = currKey;
});
export function transferCWServiceDeviceInfoToLocalDevice(device) {
    const localDevice = {
        macAddress: [device.mdc],
        deviceName: device.name,
        osName: osNameMap[device.os_type] || 'Unknown',
        deviceType: deviceTypeMap[device.belong_scope] || 'UNKNOWN',
        osVersion: device.os_desc || '',
    };
    return localDevice;
}
export function transferLocalDeviceToCWServerDevice(device) {
    const serverDevice = {
        mdc: device.macAddress.join(','),
        name: device.deviceName,
        os_type: Number.parseInt(osTypeMap[device.osName]),
        belong_scope: device.deviceType ? Number.parseInt(deviceTypeValueMap[device.deviceType]) : -1,
        os_desc: device.osVersion,
    };
    return serverDevice;
}
export function transferServerDeviceToLocalDevice(device) {
    const localDevice = {
        macAddress: device.secMdcs || [device.secMdc || ''],
        deviceName: device.secName,
        osName: osNameMap[device.secOsType] || 'Unknown',
        deviceType: deviceTypeMap[device.secBelongScope] || 'UNKNOWN',
        osVersion: device.secOsDesc || '',
    };
    return localDevice;
}
export function transferLocalDeviceToServerDevice(device) {
    const serverDevice = {
        secMdc: device.macAddress.join(','),
        secName: device.deviceName,
        secOsType: Number.parseInt(osTypeMap[device.osName]),
        secBelongScope: device.deviceType ? Number.parseInt(deviceTypeValueMap[device.deviceType]) : -1,
        secOsDesc: device.osVersion,
    };
    return serverDevice;
}
